export default { commitHash: '900ca0e', version: '7.0.0' };
